<script lang="ts">
    
    import type { Subscribable } from "../../global";

    export let state: Subscribable<Iterable<any>>;

</script>

{#each [...$state] as item}
    <slot {item}>{item}</slot>
{/each}
